import React from 'react'
import { Box, Icon, H4 } from '@maui/elements'
import { useMalwareIndicatorsFetch } from '@nautilusjs/mati-apis'
import { SearchPreviewHeader, SearchPreviewListGrid, ShowMoreDescription } from './common'

export const MalwareSearchPreview = ({ data }) => {
  const {
    id,
    name,
    description,
    operating_systems: operatingSystems = [],
    aliases = [],
    roles = [],
  } = data
  const { data: malwareIndicators } = useMalwareIndicatorsFetch(id, { adapter: 'default' })

  return (
    <Box>
      <SearchPreviewHeader
        name={name}
        icon={<Icon name='bug' size='lg' verticalAlign='-12.7px'/>}
        indicators={malwareIndicators}

      />
      <Box p='16px' background='colorBackgroundPage' color='colorTextMain'>
        <Box>
          <H4 m={0}>Summary</H4>
        </Box>
        <Box pt='16px'>
          <ShowMoreDescription description={description}/>
        </Box>
        <Box pt='16px'>
          {!!operatingSystems?.length && (
            <SearchPreviewListGrid
              title='Operating Systems'
              list={operatingSystems}
              cellWidth={['50%', '50%']}
            />
          )}
          {!!roles?.length && (
            <SearchPreviewListGrid
              title='Role'
              list={roles}
              cellWidth={['50%', '50%']}
            />
          )}
          {!!aliases?.length && (
            <SearchPreviewListGrid
              title='Reported As'
              list={aliases}
              cellWidth={['50%', '50%']}/>
          )}
        </Box>
      </Box>
    </Box>
  )
}
